export default {
  title: 'Repor palavra-passe',
  description: 'Enviaremos um link de reposição de palavra-passe para o seu e-mail.',
  sent: 'E-mail enviado.',

  form: {
    email: {
      title: 'E-mail',
      placeholder: 'Introduza o e-mail',
    },
    button: {
      title: 'Repor palavra-passe',
    },
    error_messages: {
      error1: 'Informação em falta',
    },
  },
};
